import { gql } from '@apollo/client';

import { GOAL_FRAGMENT, INVITE_FRAGMENT } from '../fragments';

export const ADD_GOAL = gql`
  mutation addGoal(
    $beneficiaryId: String!
    $goalType: GoalType
    $goalName: String
    $accountType: AccountType!
    $targetYear: Int
    $targetAmountInCents: Float!
    $recurringDepositInCents: Int!
    $recurringDepositSchedule: SipFrequency!
    $projectedRateOfReturn: Float
    $contributionsAfter18: Boolean
  ) {
    addGoal(
      input: {
        beneficiaryId: $beneficiaryId
        goalType: $goalType
        goalName: $goalName
        accountType: $accountType
        targetYear: $targetYear
        targetAmountInCents: $targetAmountInCents
        recurringDepositInCents: $recurringDepositInCents
        recurringDepositSchedule: $recurringDepositSchedule
        projectedRateOfReturn: $projectedRateOfReturn
        contributionsAfter18: $contributionsAfter18
      }
    ) {
      id
      name
      description
      type
      targetAmountInCents
      currentAmountInCents
      startDate
      endDate
      status
      contributionsAfter18
      projectedRateOfReturn
    }
  }
`;

export const EDIT_GOAL = gql`
  mutation editGoal(
    $goalId: String!
    $goalName: String
    $goalType: GoalType
    $projectedRateOfReturn: Float
    $contributionsAfter18: Boolean
    $targetYear: Int
    $targetAmountInCents: Float
  ) {
    editGoal(
      input: {
        goalId: $goalId
        goalName: $goalName
        goalType: $goalType
        projectedRateOfReturn: $projectedRateOfReturn
        contributionsAfter18: $contributionsAfter18
        targetYear: $targetYear
        targetAmountInCents: $targetAmountInCents
      }
    ) {
      id
      name
      description
      type
      targetAmountInCents
      currentAmountInCents
      startDate
      endDate
      status
      contributionsAfter18
      projectedRateOfReturn
    }
  }
`;

export const INVITE_TO_SHARE_GOAL = gql`
  ${INVITE_FRAGMENT}
  mutation inviteToShareGoal($goalId: String!, $phoneNumber: String!) {
    inviteToShareGoal(input: { goalId: $goalId, phoneNumber: $phoneNumber }) {
      ...InviteFragment
    }
  }
`;

export const DELETE_INVITE_TO_SHARE_GOAL = gql`
  mutation deleteInviteToShareGoal($shareGoalInviteId: String!) {
    deleteInviteToShareGoal(input: { shareGoalInviteId: $shareGoalInviteId })
  }
`;

export const RESEND_INVITE_TO_SHARE_GOAL = gql`
  ${INVITE_FRAGMENT}
  mutation resendInviteToShareGoal($shareGoalInviteId: String!) {
    resendInviteToShareGoal(input: { shareGoalInviteId: $shareGoalInviteId }) {
      ...InviteFragment
    }
  }
`;

export const ACTION_SHARE_GOAL_INVITE = gql`
  ${GOAL_FRAGMENT}
  mutation actionShareGoalInvite(
    $shareGoalInviteId: String!
    $action: ShareGoalInviteAction!
    $accountType: AccountType
    $projectedRateOfReturn: Float
    $contributionsAfter18: Boolean
    $recurringDepositInCents: Int
    $recurringDepositSchedule: SipFrequency
  ) {
    actionShareGoalInvite(
      input: {
        shareGoalInviteId: $shareGoalInviteId
        action: $action
        accountType: $accountType
        projectedRateOfReturn: $projectedRateOfReturn
        contributionsAfter18: $contributionsAfter18
        recurringDepositInCents: $recurringDepositInCents
        recurringDepositSchedule: $recurringDepositSchedule
      }
    ) {
      ...GoalFragment
    }
  }
`;

export const REMOVE_PARTNER_FROM_GOAL = gql`
  ${GOAL_FRAGMENT}
  mutation removePartnerFromGoal($goalId: String!, $partnerId: String!) {
    removePartnerFromGoal(input: { goalId: $goalId, partnerId: $partnerId }) {
      ...GoalFragment
    }
  }
`;
